<ng-container *ngIf="{
    date: dateSelection$ | async,
    telemetryData: evchargeTelemetryData$ | async,
    requestData: requestData$ | async,
    selectedSession: selectedSession$ | async,
    isPending: requestIsPending$ | async
  } as resolver">

  <lib-block-title
    id="evcharge-title"
    [title]="labels.title">
  </lib-block-title>

  <calendar-picker
    id="calendar-picker"
    startView="month"
    class="w-full"
    (dateSelected)="onDateSelected($event)">
    <button
      class="custom-mat-button-primary ml-0 custom-mat-button-border"
      mat-button
      [disabled]="!resolver.telemetryData?.hasData"
      (click)="toggleZoom()">
      <mat-icon class="m-0">{{ zoomed ? 'zoom_out' : 'zoom_in' }}</mat-icon>
    </button>
  </calendar-picker>

  <div
    id="summary-cards"
    class="fx-row fx-gap-3">
    <ng-container *ngIf="resolver.isPending; else summaryCards">
      <ion-skeleton-text
        class="w-full h-16 w-48"
        animated="true">
      </ion-skeleton-text>
      <ion-skeleton-text
        class="w-full h-16 w-48"
        animated="true">
      </ion-skeleton-text>
    </ng-container>

    <ng-template #summaryCards>
      <ng-container *ngIf="resolver.telemetryData && resolver.telemetryData?.hasData && !resolver.isPending">
        <app-key-value-block
        class="w-full fx-center"
        [key]="labels.dailyTotalSessions"
        [value]="(resolver.telemetryData?.totalSessions || 0).toString()"
        [bgColor]="'bg-blue-100'">
        </app-key-value-block>
        <app-key-value-block
          class="w-full fx-center"
          [key]="labels.dailyTotalEnergyDelivered"
          [value]="(resolver.telemetryData?.totalEnergy || 0).toFixed(2) + ' kWh'"
          [bgColor]="'bg-yellow-100'">
        </app-key-value-block>
      </ng-container>
    </ng-template>
  </div>

  <div
    *ngIf="resolver.isPending"
    id="day-skeleton"
    class="master-detail-layout fx-row fx-gap-4">
    <div class="fx-col fx-gap-3 fx-row-768 w-60">
      <ion-skeleton-text
        *ngFor="let _ of [].constructor(3)"
        class="h-25 w-full"
        animated="true">
      </ion-skeleton-text>
    </div>
    <div class="fx-col fx-gap-3 fx-g-1">
      <div class="fx-row fx-gap-3">
        <ion-skeleton-text
          *ngFor="let _ of [].constructor(4)"
          class="h-10 fx-g-1"
          animated="true">
        </ion-skeleton-text>
      </div>
      <div class="fx-row fx-justify-end">
        <ion-skeleton-text
          class="h-6 w-56"
          animated="true">
        </ion-skeleton-text>
      </div>
      <ion-skeleton-text class="h-100 w-full" animated="true"></ion-skeleton-text>
    </div>
  </div>

  <div
    *ngIf="!resolver.isPending && resolver.telemetryData && !resolver.telemetryData?.hasData"
    id="day-no-data"
    class="min-h-100 no-data-message fx-col fx-center fx-gap-3">
    <mat-icon class="s-20" svgIcon="no_data"></mat-icon>
    <span class="text-grey-400 tw-font-normal tw-text-base">
      {{ labels.noDataForTheSelectedPeriod }}
    </span>
  </div>


  <div
    *ngIf="!resolver.isPending && resolver.telemetryData && resolver.telemetryData?.hasData"
    class="block-bg-contrast"
    id="sessions-list">
    <div
      *ngFor="let session of resolver.telemetryData?.sessions || []; let i = index; trackBy: trackBySessionTid"
      class="fx-col min-w-50 h-fit fx-gap-3 p-3 bg-white"
      [ngClass]="{
        'session-active': resolver.selectedSession?.tid === session.tid
      }"
      (click)="selectSession(session)">
      <div class="fx-col fx-gap-2">
        <div class="body-2 text-500 text-grey-300">
          {{ labels.session }}:
        </div>
        <div class="h4 text-grey-600 ellipsed">
          {{ session.startTime | date:'HH:mm' }} - {{ (session.endTime ? (session.endTime | date:'HH:mm') : (now | date:'HH:mm')) || labels.inProgress }}
        </div>
        <div class="fx-row fx-justify-between fx-gap-2">
          <span class="body-2 text-500 text-grey-300">{{ labels.duration }}: </span>
          <span class="body-2 text-grey-400 ellipsed">{{ session.duration | duration:labels.hours:labels.minutes }}</span>
        </div>
        <div class="fx-row fx-justify-between fx-gap-2">
          <span class="body-2 text-500 text-grey-300">{{ labels.energy }}: </span>
          <span class="body-2 text-grey-400 ellipsed">{{ session.totalEnergy.toFixed(2) }} kWh</span>
        </div>
        <div class="fx-row fx-justify-between fx-gap-2">
          <span class="body-2 text-500 text-grey-300">{{ labels.maxPower }}: </span>
          <span class="body-2 text-grey-400 ellipsed">{{ session.maxPower.toFixed(1) }} kW</span>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!resolver.isPending && resolver.telemetryData && resolver.telemetryData?.hasData"
    id="day-session-detail"
    class="fx-col fx-gap-3">
    <div
      *ngIf="!resolver.selectedSession"
      class="no-selection fx-col fx-center fx-gap-3 h-full">
      <mat-icon class="s-16">info</mat-icon>
      <span class="text-grey-400">{{ labels.selectSessionToViewDetails }}</span>
    </div>

    <div
      *ngIf="resolver.selectedSession"
      class="session-chart-container fx-col fx-gap-3">
      <div class="chart-header fx-col fx-gap-3">
        <div class="fx-row fx-wrap fx-gap-3">
          <div class="session-detail-card fx-row fx-g-1 radius-4 block-bg-contrast fx-align-center fx-gap-2 p-3">
            <mat-icon class="s-6 text-grey-400">schedule</mat-icon>
            <div class="body-2 text-500 text-grey-300">
              {{ labels.session }}
            </div>
            <div class="body-1 text-grey-600 ml-auto text-nowrap">
              {{ resolver.selectedSession.startTime | date:'HH:mm' }} - {{ (resolver.selectedSession.endTime ? (resolver.selectedSession.endTime | date:'HH:mm') : (now | date:'HH:mm')) || labels.inProgress }}
              <span *ngIf="resolver.selectedSession?.isCrossDay" class="body-3 text-500 ml-1">{{ resolver.selectedSession.startTime | daysDiff:(resolver.selectedSession.endTime || now): labels.days }}</span>
            </div>
          </div>
          <div class="session-detail-card fx-row fx-g-1 radius-4 block-bg-contrast fx-align-center fx-gap-2 p-3">
            <mat-icon class="s-6 text-grey-400">battery_charging_full</mat-icon>
            <div class="body-2 text-500 text-grey-300">
              {{ labels.energy }}
            </div>
            <div class="body-1 text-grey-600 ml-auto text-nowrap">
              {{ resolver.selectedSession.totalEnergy.toFixed(2) }} kWh
            </div>
          </div>
          <div class="session-detail-card fx-row fx-g-1 radius-4 block-bg-contrast fx-align-center fx-gap-2 p-3">
            <mat-icon class="s-6 text-grey-400">power</mat-icon>
            <div class="body-2 text-500 text-grey-300">
              {{ labels.maxPower }}
            </div>
            <div class="body-1 text-grey-600 ml-auto text-nowrap">
              {{ resolver.selectedSession.maxPower.toFixed(1) }} kW
            </div>
          </div>
          <div
            *ngIf="resolver.selectedSession.batteryInfo?.strategy"
            class="session-detail-card fx-row fx-g-1 radius-4 block-bg-contrast fx-align-center fx-gap-2 p-3">
            <mat-icon class="s-6 text-grey-400">{{ resolver.selectedSession.batteryInfo?.strategy === AHevchStrategyEnum.fast ? 'bolt' : 'eco' }}</mat-icon>
            <div class="body-2 text-500 text-grey-300">
              {{ labels.strategy }}
            </div>
            <div class="body-1 text-grey-600 ml-auto text-nowrap">
              {{ resolver.selectedSession.batteryInfo?.strategy }}
            </div>
          </div>
        </div>
        <button
          *ngIf="resolver.selectedSession?.batteryInfo"
          type="button"
          class="fx-row custom-mat-button-primary"
          mat-button
          (click)="showBatteryDetails = !showBatteryDetails">
          <mat-icon>{{ showBatteryDetails ? 'do_not_disturb_on' : 'add_circle' }}</mat-icon>
          <span>{{ labels.moreDetails }}</span>
        </button>

        <div
          *ngIf="showBatteryDetails"
          id="battery-details"
          class="fx-row fx-gap-3 fx-justify-evenly mt-2">
          <!-- Battery protection + SoC limit -->
          <div class="fx-g-1 radius-4 block-bg-contrast p-3 fx-col fx-gap-2">
            <div class="fx-row fx-center fx-gap-2 body-2 text-500 text-grey-300">
              <mat-icon class="s-5 text-grey-400">shield_with_heart</mat-icon>
              <span>{{ labels.batteryProtection }}</span>
            </div>
            <div class="body-2 text-grey-400">
              {{ labels.batteryProtectionDescription }}
            </div>
            <div class="fx-row fx-align-center fx-gap-2 fx-justify-between">
              <div class="body-2 text-500 text-grey-300">{{ labels.batteryProtection }}</div>
              <div class="body-1 text-grey-400 ml-auto">
                {{ resolver.selectedSession.batteryInfo?.batteryProtectionEnabled ? labels.enable : labels.disable }}
              </div>
            </div>
            <div
              *ngIf="resolver.selectedSession.batteryInfo?.batteryProtectionEnabled"
              class="fx-row fx-align-center fx-gap-2 fx-justify-between">
              <div class="body-2 text-500 text-grey-300">{{ labels.socLimit }}</div>
              <div class="body-1 text-grey-400 ml-auto">{{ resolver.selectedSession.batteryInfo?.socLimit }}%</div>
            </div>
          </div>

          <!-- Power import limit + value -->
          <div class="fx-g-1 radius-4 block-bg-contrast p-3 fx-col fx-gap-2">
            <div class="fx-row fx-center fx-gap-2 body-2 text-500 text-grey-300">
              <mat-icon class="s-5 text-grey-400">electrical_services</mat-icon>
              <span>{{ labels.powerImportLimit }}</span>
            </div>
            <div class="body-2 text-grey-400">
              {{ labels.powerImportLimitDescription }}
            </div>
            <div class="fx-row fx-align-center fx-gap-2 fx-justify-between">
              <div class="body-2 text-500 text-grey-300">{{ labels.powerImportLimit }}</div>
              <div class="body-1 text-grey-400 ml-auto">
                {{ resolver.selectedSession.batteryInfo?.powerImportLimitEnabled ? labels.enable : labels.disable }}
              </div>
            </div>
            <div
              *ngIf="resolver.selectedSession.batteryInfo?.powerImportLimitEnabled"
              class="fx-row fx-align-center fx-gap-2 fx-justify-between">
              <div class="body-2 text-500 text-grey-300">{{ labels.powerImportLimitValue }}</div>
              <div class="body-1 text-grey-400 ml-auto">{{ resolver.selectedSession.batteryInfo?.powerImportLimitValue }}%</div>
            </div>
          </div>

          <!-- Parallel mode -->
          <div class="fx-g-1 radius-4 block-bg-contrast p-3 fx-col fx-gap-2">
            <div class="fx-row fx-center fx-gap-2 body-2 text-500 text-grey-300">
              <mat-icon class="s-5 text-grey-400">view_stream</mat-icon>
              <span>{{ labels.parallelMode }}</span>
            </div>
            <div class="body-2 text-grey-400">
              {{ labels.parallelModeDescription }}
            </div>
            <div class="fx-row fx-align-center fx-gap-2 fx-justify-between">
              <div class="body-2 text-500 text-grey-300">{{ labels.parallelMode }}</div>
              <div class="body-1 text-grey-400 ml-auto">
                {{ resolver.selectedSession.batteryInfo?.parallelEnabled ? labels.enable : labels.disable }}
              </div>
            </div>
          </div>
        </div>

        <app-energy-source-selector
          *ngIf="selectedSources$ | async as selectedSources"
          id="source-selector"
          [source]="selectedSources"
          [options]="options"
          (selection)="clickSource($event)">
        </app-energy-source-selector>
      </div>

      <div
        *ngIf="chartOptions$ | async as chartOptions"
        class="session-chart block-bg-contrast"
        echarts
        [options]="chartOptions">
      </div>
    </div>
  </div>
</ng-container>
